(function () {
  var hdr = document.querySelector('[data-header]');
  var burger = document.querySelector('[data-nav-toggle]');
  if (hdr && burger) {
    burger.addEventListener('click', function () {
      var open = hdr.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var main = root.querySelector('[data-main-image]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (main) {
          main.src = btn.getAttribute('data-src');
          main.srcset = btn.getAttribute('data-srcset') || '';
          main.alt = btn.getAttribute('data-alt') || '';
        }
        thumbs.forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
    var data = root.querySelector('[data-variants]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var addBtn = root.querySelector('[data-add]');
    var currency = root.getAttribute('data-currency') || 'EUR';
    var fmt = function (cents) {
      return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: currency });
    };
    root.querySelectorAll('[data-option] input').forEach(function (input) {
      input.addEventListener('change', function () {
        var selected = [];
        root.querySelectorAll('[data-option]').forEach(function (set) {
          var c = set.querySelector('input:checked');
          selected.push(c ? c.value : null);
        });
        var v = variants.filter(function (x) {
          return x.options.every(function (o, i) { return o === selected[i]; });
        })[0];
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Nicht verfügbar'; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = fmt(v.price);
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
        }
        if (v.featured_image && main) {
          var src = v.featured_image.src;
          main.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=900';
          main.removeAttribute('srcset');
        }
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u);
        } catch (e) {}
      });
    });
  });
  document.querySelectorAll('[data-sub-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var li = btn.parentElement;
      var open = li.classList.toggle('sub-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
})();
